<ng-container *ngIf="buttonType === 'flat'">
	<button
		mat-flat-button
		[color]="themeColor"
		(click)="startFundraiserPage()"
		i18n="@@button_startFundraiser"
	>
		Start Fundraiser
	</button>
</ng-container>
<ng-container *ngIf="buttonType === 'stroked'">
	<button
		mat-stroked-button
		[color]="themeColor"
		(click)="startFundraiserPage()"
		id="start_fundraiser"
		i18n="@@button_startFundraiser"
		fxFlex="100%"
	>
		Start Fundraiser
	</button>
</ng-container>
<ng-container *ngIf="buttonType === 'homepage1'">
	<button
		mat-flat-button
		color="accent"
		(click)="startFundraiserPage()"
		class="hover-on-svg"
	>
		<span ngClass="p-xs" class="mat-headline-6" i18n="@@button_startFundraiser"
			>Start Fundraiser</span
		>
	</button>
</ng-container>
<ng-container *ngIf="buttonType === 'homepage2'">
	<button mat-flat-button color="accent" (click)="startFundraiserPage()">
		<span ngClass="p-s" class="mat-subtitle" i18n="@@button_startFundraiser"
			>Start Fundraiser</span
		>
	</button>
</ng-container>
<ng-container *ngIf="buttonType === 'homepage3'">
	<button
		mat-flat-button
		color="accent"
		(click)="startFundraiserPage()"
		class="hover-on-svg"
	>
		<span
			ngClass.gt-sm="p-l-xxl p-r-xxl"
			ngClass.lt-md="p-l-xl p-r-xl"
			class="mat-headline-6"
			i18n="@@button_startFundraiser"
		>
			Start Fundraiser
		</span>
	</button>
</ng-container>
<ng-container *ngIf="buttonType === 'homepage5'">
	<button
		mat-flat-button
		color="accent"
		(click)="startFundraiserPage()"
		class="hover-on-svg"
	>
		<div
			ngClass="p-l-l p-r-l"
			class="mat-card-title"
			i18n="@@button_startFundraiser"
		>
			Start Fundraiser
		</div>
	</button>
</ng-container>
<ng-container *ngIf="buttonType === 'homepage6'">
	<button
		mat-flat-button
		color="accent"
		(click)="startFundraiserPage()"
		class="hover-on-svg"
	>
		<div
			ngClass="p-l-l p-r-l"
			class="mat-card-title"
			i18n="@@button_startFundraiser"
		>
			Start Fundraiser
		</div>
	</button>
</ng-container>
